import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "1-trend-03-topleft",
  "use": "1-trend-03-topleft-usage",
  "viewBox": "0 0 1000 1000",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1000 1000\" xmlns=\"http://www.w3.org/2000/svg\" id=\"1-trend-03-topleft\"><path d=\"M661.43 259.774h-364.149c-28.44 0-51.491 23.051-51.491 51.491v364.149c0 28.44 23.051 51.491 51.491 51.491s51.491-23.051 51.491-51.491v-239.829l349.073 349.073c20.119 20.119 52.711 20.119 72.831 0s20.119-52.711 0-72.831l-349.073-349.073h239.829c14.202 0.001 27.093-5.754 36.415-15.076s15.094-22.195 15.076-36.415c0-28.44-23.051-51.491-51.491-51.491z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol